<template>
  <div
    :class="tabActiveClass"
    id="fiscal"
    role="tabpanel"
    aria-labelledby="fiscal-tab"
  >
    <h4 class="form-title hide-mobile">{{ transPeralbaPro.item839 }}</h4>
    <hr class="hide-mobile" />
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item845 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item846 }}</p>
      </div>
      <div class="col-md-6">
        <form-input
          fieldName="fiscalName"
          :fieldLabel="transPeralbaPro.item847"
          fieldType="text"
          :fieldValue="fiscalName"
          :inputPlaceholder="transPeralbaPro.item847"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalName')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="nif"
          :fieldLabel="transPeralbaPro.item848"
          fieldType="text"
          :fieldValue="nif"
          :inputPlaceholder="transPeralbaPro.item848"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'nif')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="fiscalAddress"
          :fieldLabel="transPeralbaPro.item849"
          fieldType="text"
          :fieldValue="fiscalAddress"
          :inputPlaceholder="transPeralbaPro.item849"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalAddress')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="fiscalZipcode"
          :fieldLabel="transPeralbaPro.item850"
          fieldType="text"
          :fieldValue="fiscalZipcode"
          :inputPlaceholder="transPeralbaPro.item850"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalZipcode')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="fiscalCity"
          :fieldLabel="transPeralbaPro.item851"
          fieldType="text"
          :fieldValue="fiscalCity"
          :inputPlaceholder="transPeralbaPro.item851"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalCity')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="fiscalProvince"
          :fieldLabel="transPeralbaPro.item852"
          fieldType="text"
          :fieldValue="fiscalProvince"
          :inputPlaceholder="transPeralbaPro.item852"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalProvince')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="fiscalCountry"
          :fieldLabel="transPeralbaPro.item853"
          fieldType="text"
          :fieldValue="fiscalCountry"
          :inputPlaceholder="transPeralbaPro.item853"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'fiscalCountry')"
          @updateValue="updateFormValue"
        />

        <form-radio-button
          :fieldValue="selectedNumberWorkers"
          fieldName="selectedNumberWorkers"
          :fieldLabel="transPeralbaPro.item854"
          :items="numberWorkers"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'selectedNumberWorkers')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h5 class="form-subtitle">{{ transPeralbaPro.item855 }}</h5>
        <p class="form-subtitle-p">{{ transPeralbaPro.item856 }}</p>
      </div>
      <div class="col-md-6">
        <form-input
          fieldName="nombreAdmin"
          :fieldLabel="transPeralbaPro.item857"
          fieldType="text"
          :fieldValue="nombreAdmin"
          :inputPlaceholder="transPeralbaPro.item857"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'nombreAdmin')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="email"
          :fieldLabel="transPeralbaPro.item793"
          fieldType="email"
          :fieldValue="email"
          :inputPlaceholder="transPeralbaPro.item793"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'email')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="mobileAdmin"
          :fieldLabel="transPeralbaPro.item824"
          fieldType="telephone"
          :fieldValue="mobileAdmin"
          :inputPlaceholder="transPeralbaPro.item824"
          :is-required="true"
          :has-error="fieldHasErrors('fiscalData', 'mobileAdmin')"
          @updateValue="updateFormValue"
        />

        <form-input
          fieldName="phoneAdmin"
          :fieldLabel="transPeralbaPro.item825"
          fieldType="telephone"
          :fieldValue="phoneAdmin"
          :inputPlaceholder="transPeralbaPro.item826"
          :has-error="fieldHasErrors('fiscalData', 'phoneAdmin')"
          @updateValue="updateFormValue"
        />
      </div>
    </div>
    <div class="w-100" style="height: 100px">
      <button
        type="button"
        :disabled="disabledForm"
        class="btn-per-dark mt-4 mb-2"
        @click="$emit('validateRegisterFiscalData')"
        style="float: right"
      >
        {{ transPeralbaPro.item827 }}<i class="fas fa-arrow-right ms-3"></i>
      </button>
    </div>
  </div>
</template>
<script>
import FormInput from "../../../../../components/front/Inputs/FormInput";
import FormRadioButton from "../../../../../components/front/Inputs/FormRadioButton";
import sections from "../../mixins/sections";

export default {
  mixins: [sections],
  components: { FormInput, FormRadioButton },
  props: [
    "activeTab",
    "fiscalName",
    "numberWorkers",
    "nif",
    "fiscalZipcode",
    "fiscalCity",
    "fiscalProvince",
    "fiscalCountry",
    "nombreAdmin",
    "email",
    "mobileAdmin",
    "phoneAdmin",
    "fiscalAddress",
    "selectedNumberWorkers",
    "disabledForm",
    "errors",
    "transPeralbaPro",
  ],
};
</script>
